/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './retrieve_customer';
import './retrieve_customer_limits';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "CustomerService": {
                    "methods": {
                      "RetrieveCustomer": {
                        "requestType": ".squareup.sfs.external.service.RetrieveCustomerRequest",
                        "responseType": ".squareup.sfs.external.service.RetrieveCustomerResponse"
                      },
                      "RetrieveCustomerLimits": {
                        "requestType": ".squareup.sfs.external.service.RetrieveCustomerLimitsRequest",
                        "responseType": ".squareup.sfs.external.service.RetrieveCustomerLimitsResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CustomerService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for Savings Customers
 * --
 *
 * SOURCE CustomerService @ squareup/sfs/external/services/customer/customer_service.proto at 13:1
 */
export const CustomerService = $root.lookupService('squareup.sfs.external.service.CustomerService');